import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getGochisData = params =>
  axios.get(`${API_HOST}/v2/gochi/admin`, { params, withCredentials: true });

export const getGenGochisData = params =>
  axios.get(`${API_HOST}/gochis/genGochi/search`, {
    params,
    withCredentials: true
  });

export const updateGenGochisData = params =>
  axios.put(`${API_HOST}/gochis/genGochi/status`, params, {
    withCredentials: true
  });

export const getGochisDataShop = params =>
  axios.get(`${API_HOST}/v2/gochi/shop`, { params, withCredentials: true });

export const getGochiDetailData = couponId =>
  axios.get(`${API_HOST}/gochis/${couponId}`, { withCredentials: true });

export const downloadGochiData = params =>
  axios.get(`${API_HOST}/v2/gochi/admin/download`, {
    params,
    withCredentials: true,
    responseType: 'arraybuffer'
  });

export const downloadGochiEsData = params =>
  axios.get(`${API_HOST}/es/gochis/download`, {
    params,
    withCredentials: true
  });

export const downloadGochiDataShop = params =>
  axios.get(`${API_HOST}/v2/gochi/shop/download`, {
    params,
    withCredentials: true,
    responseType: 'arraybuffer'
  });

export const resendMailGochiData = params =>
  axios.post(`${API_HOST}/v3/gochi/resendEmail`, params, {
    withCredentials: true
  });

export const resendGochiData = params =>
  axios.post(`${API_HOST}/v3/gochi/resendGochi`, params, {
    withCredentials: true
  });

export const sendReplyMessage = params =>
  axios.post(`${API_HOST}/v2/gochi/emailMessage`, params, {
    withCredentials: true
  });

export const rejectGochiData = params =>
  axios.post(`${API_HOST}/stripe/charge/event/reject`, params, {
    withCredentials: true
  });

export const postRefund = params =>
  axios.post(`${API_HOST}/payment/refund`, params, {
    withCredentials: true
  });

export const gochiImportFileData = params =>
  axios.post(`${API_HOST}/gochis/uploadGochiFile`, params, {
    withCredentials: true
  });

export const deleteGochiData = gochiBillId =>
  axios.delete(`${API_HOST}/gochis/${gochiBillId}`, { withCredentials: true });

export const getGochisDataEs = params =>
  axios.get(`${API_HOST}/es/gochis`, { params, withCredentials: true });

export const getGochiOneToNData = params =>
  axios.get(`${API_HOST}/gochis/oneToNTickets`, {
    params,
    withCredentials: true
  });

export const changeTicketToNonUse = params =>
  axios.put(`${API_HOST}/gochis/changeTicketToNonUse`, params, {
    withCredentials: true
  });

export const changeTicketToNTicket = params =>
  axios.put(`${API_HOST}/gochis/changeTicketToNTicket`, params, {
    withCredentials: true
  });

export const sendShashokuReplyMessage = params =>
  axios.post(`${API_HOST}/shops/replyShashokuShopMessage`, params, {
    withCredentials: true
  });

export const getGochisByGochiCode = params =>
  axios.get(`${API_HOST}/gochi-code/info`, { params, withCredentials: true });

export const useGochiCode = params =>
  axios.put(`${API_HOST}/gochi-code/use`, params, {
    withCredentials: true
  });

export const listBatchGochiChargeData = params =>
  axios.get(`${API_HOST}/autoChargeGochi/list`, {
    params,
    withCredentials: true
  });

export const validateBatchGochiChargeData = params =>
  axios.post(`${API_HOST}/autoChargeGochi/validate`, params, {
    withCredentials: true
  });

export const batchGochiChargeImportFileData = params =>
  axios.post(`${API_HOST}/autoChargeGochi/import`, params, {
    withCredentials: true
  });

export const adminUseGochiKidData = params =>
  axios.post(`${API_HOST}/gochi-kid/admin/use`, params, {
    withCredentials: true
  });

export const adminUseGochiKidGroupSpecialData = params =>
  axios.post(`${API_HOST}/gochi-kid/admin/group-special/use`, params, {
    withCredentials: true
  });

export const getListGochiKidUsedByAdminData = params =>
  axios.get(`${API_HOST}/gochi-kid/admin/use`, {
    params,
    withCredentials: true
  });

export const deleteCommentShashokuData = params =>
  axios.put(`${API_HOST}/shashoku/update-comment`, params, {
    withCredentials: true
  });

export const getGochiGroupCampaignData = params =>
  axios.get(`${API_HOST}/v2/gochi/group/campaign`, {
    params,
    withCredentials: true
  });

export const downloadGochiGroupCampaignData = params =>
  axios.get(`${API_HOST}/v2/gochi/group/campaign/download`, {
    params,
    withCredentials: true,
    responseType: 'arraybuffer'
  });

export const getUpdateAmountHistoryDetailData = params =>
  axios.get(`${API_HOST}/edit-amount/history/detail`, {
    params,
    withCredentials: true
  });

export const getUpdateAmountHistoryListData = params =>
  axios.get(`${API_HOST}/edit-amount/history`, {
    params,
    withCredentials: true
  });

export const downloadUpdateAmountHistoryListData = params =>
  axios.get(`${API_HOST}/edit-amount/history/download`, {
    params,
    withCredentials: true,
    responseType: 'arraybuffer'
  });

export const getRemainAmountUpdateAmountData = params =>
  axios.get(`${API_HOST}/edit-amount/remain-amount`, {
    params,
    withCredentials: true
  });

export const updateAmountEducationSystemData = (params, crfsToken) =>
  axios.post(`${API_HOST}/edit-amount`, params, {
    withCredentials: true,
    headers: {
      csrf_token: crfsToken
    }
  });

export const updateGochiKidReceiptFlagData = params =>
  axios.put(`${API_HOST}/gochi-kid/update-gochi-kid-receipt-flag`, params, {
    withCredentials: true
  });

export const getListGochiKidUseData = params =>
  axios.get(`${API_HOST}/gochi-kid/use`, {
    params,
    withCredentials: true
  });

export const unusedGochiKidData = params =>
  axios.post(`${API_HOST}/gochi-kid/admin/unuse`, params, {
    withCredentials: true
  });

export const getGochiGroupGochiKidData = params =>
  axios.get(`${API_HOST}/v2/gochi/group/gochi-kid`, {
    params,
    withCredentials: true
  });

export const downloadGochiGroupGochiKidData = params =>
  axios.get(`${API_HOST}/v2/gochi/group/gochi-kid/download`, {
    params,
    withCredentials: true,
    responseType: 'arraybuffer'
  });
